import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Logger Service
 * Provides production-safe logging with environment-based control
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly isProduction = environment.production;

  /**
   * Log informational messages (always logged)
   */
  info(message: string, ...args: unknown[]): void {
    console.log(`[INFO] ${message}`, ...args);
  }

  /**
   * Log debug messages (only in development)
   */
  debug(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  }

  /**
   * Log warning messages (always logged)
   */
  warn(message: string, ...args: unknown[]): void {
    console.warn(`[WARN] ${message}`, ...args);
  }

  /**
   * Log error messages (always logged)
   */
  error(message: string, error?: unknown, ...args: unknown[]): void {
    if (error) {
      console.error(`[ERROR] ${message}`, error, ...args);
    } else {
      console.error(`[ERROR] ${message}`, ...args);
    }
  }
}
